// Function to hide reviews with low ratings
function hideLowRatingReviews() {
    document.querySelectorAll('.oke-w-review').forEach(function(review) {
        var ratingText = review.textContent || review.innerText;
        if (ratingText.includes("Rated 1 out") || ratingText.includes("Rated 2 out") || ratingText.includes("Rated 3 out")) {
            var listItem = review.closest('.oke-w-reviews-list-item');
            if (listItem) {
                listItem.style.display = 'none';
                // console.log('Hiding low rating review:', listItem);
            }
        }
    });
}

// Function to modify the review counts
function modifyReviewCounts() {
    document.querySelectorAll('.oke-w-breakdownModule-distribution-count').forEach(function(countElement) {
        if (countElement.textContent.trim() === '1' || countElement.textContent.trim() === '2') {
            countElement.textContent = '0';
            console.log('Modifying review count to 0 for:', countElement);
        }
    });
}

// Function to modify the review bars for 1-star and 2-star ratings
function modifyReviewBars() {
    document.querySelectorAll('.oke-w-breakdownModule-distribution-label-number').forEach(function(label) {
        if (label.textContent.trim() === '1') {
            const oneStarBarFill = label.closest('.oke-w-breakdownModule-distribution-bar').querySelector('.oke-w-breakdownModule-distribution-bar-fill');
            if (oneStarBarFill) {
                oneStarBarFill.style.width = '0%';
                console.log('Setting 1-star bar width to 0%');
            }
        } else if (label.textContent.trim() === '2') {
            const twoStarBarFill = label.closest('.oke-w-breakdownModule-distribution-bar').querySelector('.oke-w-breakdownModule-distribution-bar-fill');
            if (twoStarBarFill) {
                twoStarBarFill.style.width = '0%';
                console.log('Setting 2-star bar width to 0%');
            }
        }
    });
}

// Function to continuously modify the review bars
function continuouslyModifyBars() {
    const interval = setInterval(modifyReviewBars, 500);
    setTimeout(() => {
        clearInterval(interval);
        console.log('Stopped modifying bars');
    }, 10000); // Adjust the duration as needed
}

// MutationObserver callback
function observerCallback(mutations, observer) {
    mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
            hideLowRatingReviews();
            modifyReviewCounts();
            continuouslyModifyBars();
        }
    });
}

// Start observing
const observer = new MutationObserver(observerCallback);
observer.observe(document.body, { childList: true, subtree: true });

// Initial run
hideLowRatingReviews();
modifyReviewCounts();
continuouslyModifyBars();
